import { getDataFromResponceError, getStatusFromResponceError } from '../shared/utils';
import l10n from '../shared/strings';

/**
 * Build a user facing message for a failed upload request.
 * The server does not always answer with a json body, so interpolating
 * `msg`/`subcode` blindly renders literal "undefined" in the upload panel.
 * @param {Error|AxiosError} error
 * @param {string?} fallbackMessage - used when the response carries nothing readable
 * @returns {string}
 */
export default function buildUploadErrorMessage(error, fallbackMessage) {
  const msg = getDataFromResponceError(error, 'msg');
  const subcode = getDataFromResponceError(error, 'subcode');

  if (msg) return subcode ? `${subcode}: ${msg}` : msg;

  if (getStatusFromResponceError(error) === 403) {
    return l10n.IMPORT.textDontHavePermissionToUpload;
  }

  return fallbackMessage || l10n.IMPORT.textCantSaveImageToDB;
}
